import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import React from 'react';


import AvatarMobile from './AvatarPlaceholder';
import RatingStars from './ratingStars';

import PageHeaderTitle from '../../Common/Profile/PageHeaderTitle';

import { Spin } from 'antd';

import AccountSetupSteps from '../AccountSetup/AccountSetupSteps';

function GreenSection(props) {
	const fullName =
		props.currentUser.first_name.trim() && props.currentUser.last_name.trim()
			? props.currentUser.first_name.trim() + ' ' + props.currentUser.last_name.trim()
			: props.currentUser.name.trim() || '';
	// const rating = Session.get(APP_STRING.RATING);

	let formatFullName = fullName.split(' ').map(m => m[0]?.toUpperCase() + m?.slice(1));

	formatFullName = Object.values(formatFullName).join(' ');

	const rating = () => {
		return parseFloat(props.kycStatus.rating).toFixed(1);
	};

	return (
		<>
			<Grid alignItems="center" className="green_section_container" item sm={12} spacing={2} xs={12}>
				<PageHeaderTitle onClick={() => window.openScreen('LOAN_LIST')} title="Profile" />
				<Paper className="bg-green bg-mobile" style={{ height: '100%' }}>
					<div className="profile-img-mobile">
						<AvatarMobile />
					</div>

					<div className="profile_basic_info">
						<Typography
							className={formatFullName.length > 18 ? 'small' : null}
							component="h5"
							gutterBottom
							textAlign="center"
							variant="h4">
							{formatFullName}
							&nbsp; &nbsp;
						</Typography>

						{props.children}

						<Typography component="p" gutterBottom textAlign="center">
							Philippines
						</Typography>

						<div>
							{props.loading ? (
								<Spin size="medium" />
							) : rating() > 0 ? (
								<div style={{ display: 'flex', gap: '5px' }}>
									<RatingStars page="profile" stars={rating()} />
									<p>Rating: {rating()}</p>
								</div>
							) : (
								<p> (No ratings yet) </p>
							)}
						</div>
					</div>
				</Paper>
			</Grid>
			<div className="account_creation_container">
				<AccountSetupSteps
					error={props.error}
					loading={props.loading}
					kycStatus={props.kycStatus}
					redirectToKyc={props.redirectToKyc}
					userId={props.currentUser.id}
				/>
			</div>
		</>
	);
}

export default GreenSection;
